<div class="histogram-chart">
  <canvas #histogramChart id="histogramChart"></canvas>
</div>
